export default __webpack_public_path__ + "static/media/Category-Fine-Motor-transparent.8dd05a41.png";